<template>
  <div>
    <NavTop class="navbar"></Navtop>
    <!-- banner -->
    <div class="banner">
      <img class="banner_img" src="../../assets/images/图片3.png" alt>
    </div>
    <!-- 内容 -->
    <div class="conventionContent content">
      <div class="conventionContent_left">
        <div class="conventionContent_left_top">
          相关连接
        </div>
        <div class="conventionContent_left_bottom">
          <ul>
            <li>
              <a style="border-radius: 0; border: none; line-height: 20px;" target="_blank"
                 href="https://www.12371.cn/">学习贯彻习近平新时代中国特色社会主义思想主题教育官网</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="conventionContent_right">
        <div class="conventionContent_right_title">
          <div class="conventionContent_right_title_l">专题专栏</div>
          <div class="conventionContent_right_title_r">
            <span @click="goHome('/')">首页</span>/
            <span @click="goconvention('/convention')">专题专栏</span>
          </div>
        </div>
        <div class="conventionContent_right_box">
          <ul>
            <li v-for="(item,index) in zhuTData" :key="index" @click="routerpush(item)">
              <div>
                <span>{{ item.title }}</span>
                <span>{{ extractDate(item.publishTime) }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="conventionContent_right_listpage"></div>
      </div>
    </div>
    <!-- 底部信息 -->
    <div class="bottom">
      <div class="bottomCenter" @click="goTiaoZhuan('/thematic/education',0)">
        <img src="../../assets/images/图片1.png"/>
      </div>
      <div class="bottomCenter" @click="goTiaoZhuan('http://www.moe.gov.cn/jyb_xwfb/xw_zt/moe_357/s7865/s8417/',1)">
        <img src="../../assets/images/图片2.png"/>
      </div>
    </div>
  </div>
</template>
<script>
import home from '../../api/home'

export default {
  data () {
    return {
      // 底部数据
      bottomData: [],
      // 主题教育内容
      zhuTData: []
    }
  },
  created () {
    this.getList()
  },
  mounted () {

  },
  methods: {
    // 获取列表
    async getList () {
      try {
        const res = await home.getWenZhang({tabBarId: 534})
        this.zhuTData = res.rows
      } catch (e) {
        console.log(e)
      }
    },
    // 点击底部跳转
    goTiaoZhuan (path, index) {
      switch (index) {
        case 0:
          const routeData2 = this.$router.resolve(path)
          window.open(routeData2.href, '_blank')
          break
        case 1:
          window.open(path, '_blank')
          break
      }
    },
    extractDate (dateTimeStr) {
      // 假设日期时间格式总是 "YYYY-MM-DD HH:mm:ss"
      if (dateTimeStr) {
        return dateTimeStr.substring(0, 10)
      }
    },
    goHome (to) {
      this.$router.push(to)
    },
    goconvention (url) {
      this.$router.push(url)
    },
    routerpush (item) {
      this.$router.push('/common/section/detail' + '/' + 1 + '/' + item.tabBarId + '/' + item.id)
    }
  }
}
</script>
<style lang="less" scoped>
// banner
.banner {
  .banner_img {
    width: 100%;
    height: 452px;
    object-fit: fill;
  }
}

//内容
.conventionContent {
  margin-top: 50px !important;
  margin-bottom: 50px !important;
  display: flex;
  justify-content: space-between;

  .conventionContent_left {
    width: 193px;

    .conventionContent_left_top {
      width: 193px;
      height: 38px;
      background: #9e070e;
      line-height: 38px;
      text-align: center;
      font-size: 16px;
      color: #fff;
    }

    .conventionContent_left_bottom {
      width: 193px;
      height: 200px;
      background: #f8f8f8;
      border-top: none;

      ul {
        padding: 10px;
        display: inline-table;

        li {
          margin-right: 10px;
          display: inline-block;
          margin-bottom: 10px;

          a {
            display: inline-block;
            font-size: 14px;
            color: #c1c1c1;
            border: 1px solid #c1c1c1;
            padding: 5px 10px;
            border-radius: 25px;
            text-decoration: none;
          }
        }
      }
    }
  }

  .conventionContent_right {
    width: 960px;

    .conventionContent_right_title {
      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;

      .conventionContent_right_title_l {
        padding: 0 15px;
        line-height: 45px;
        font-size: 20px;
        font-weight: bold;
        color: #444;
        border-bottom: 2px solid #9e070e;
      }

      .conventionContent_right_title_r {
        font-size: 14px;
        color: #666;

        span {
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }

    .conventionContent_right_box {
      padding: 20px 0;

      ul {
        border-bottom: 1px solid #eee;
        padding-bottom: 30px;

        li {
          margin: 0;
          padding: 0;

          div {
            width: 100%;
            height: 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #444;
            text-decoration: none;

            span {
              &:hover {
                color: #7c2c2c;
                cursor: pointer;
              }

              &:nth-child(1) {
                width: 80%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 16px;
              }

              &:nth-child(2) {
                width: 20%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                text-align: right;
              }
            }
          }
        }
      }
    }

    .conventionContent_right_listpage {
      margin-top: 10px;
      width: 960px;
      height: 40px;
    }
  }
}

// 底部信息
.bottom {
  width: 1200px;
  //height: 275px;
  height: 402px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .bottomCenter {
    height: 210px;

    img {
      width: 580px;
      height: 337px;
      //height: 210px;

      &:nth-last-child(1) {
      }

      &:hover {
        cursor: pointer;
      }
    }
  }
}

ul, li {
  list-style: none;
}

.nav:hover {
  background-color: #9e070e;
  color: #fff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}

.dropdown_menu {
  transform: translate(0, -6%);
  width: 120px;

  .el-dropdown-menu__item {
    text-align: center;
  }

  .el-dropdown-menu__item:hover {
    background-color: #8d080e;
    color: #fff;
  }
}

.content {
  width: 1200px;
  margin: 0 auto;
}

.dropdown:hover {
  background-color: #9e070e;
}

</style>



// WEBPACK FOOTER //
// src/views/convention/convention.vue